interface getRouteWithCurrentHubIdProps {
  currentHubId: string;
  route: string;
  withoutPrefixBar?: boolean;
  withHubPrefix?: boolean;
}

export const getRouteWithCurrentHubId = ({
  currentHubId,
  route,
  withoutPrefixBar = false,
  withHubPrefix = false,
}: getRouteWithCurrentHubIdProps) => {
  return `${withoutPrefixBar ? "" : "/"}${withHubPrefix ? "hub/" : ""}${currentHubId}/${route}`;
};
